import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35462556"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "favorite-btn",
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.emitOnClick(!$props.shouldBeFilled)), ["stop"])),
    "aria-label": $props.shouldBeFilled ? '즐겨찾기 해제' : '즐겨찾기 추가'
  }, [
    ($props.shouldBeFilled)
      ? (_openBlock(), _createBlock($setup["InlineSvg"], {
          key: 0,
          src: $props.favoritedIcon,
          alt: "즐겨찾기 해제",
          "aria-hidden": "true"
        }, null, 8 /* PROPS */, ["src"]))
      : (_openBlock(), _createBlock($setup["InlineSvg"], {
          key: 1,
          src: $props.unFavoritedIcon,
          alt: "즐겨찾기 추가",
          "aria-hidden": "true"
        }, null, 8 /* PROPS */, ["src"]))
  ], 8 /* PROPS */, _hoisted_1))
}